/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */

import styled from 'styled-components';

export const PlaceHolderContainer = styled.div`
  // display: flex;
  cursor: pointer;
  justify-content: flex-start;
  align-items: center;
  margin: 1.5rem;
  @media (max-width: 480px) {
    align-items: flex-start;
    margin: 1rem 0.5rem;
  }
`;
